import type { MachineSwing } from 'src/Types/SwingTypes'

export const isUnselectedSequenceSwing = (switchBaneDataId: string, pointMachineSwing: MachineSwing) => {
  return pointMachineSwing.isFromSequence && pointMachineSwing.switchBaneDataId !== switchBaneDataId
}
